export const gift_set = [
  {
    id: "i1",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw8c288955/crop/026459591_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    name: "Mahogany Teakwood Intense",
    category1: "3-Wick Candle",
    Amount: "13.50",
    Rating: "4.5",
  },
  {
    id: "i2",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwc6262222/crop/026177563_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    name: "Teakwood",
    category1: "3-in-1-Hair, Face & Body Wash",
    Amount: "13.50",
    Rating: "5",
  },
  {
    id: "i3",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwdfe0df3d/crop/026437376_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Mahogany Teakwood",
    category1: "Single Wick Candle",
    Amount: "15.50",
    Rating: "4.5",
  },
  {
    id: "i4",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw93669fb8/crop/026479920_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Everyday Gray",
    category1: "Travel Toiletry Bag",
    Amount: "14.50",
    Rating: "4",
    desc: "What it smells like: a sweet, heart-warming celebration. Fragrance notes: pink prosecco, sparkling quince, crystal peonies, gilded amber and amaretto crème",
  },
  {
    id: "i5",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw71288ec8/crop/026447056_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Hero",
    category1: "Ultimate Hydration Body Cream",
    Amount: "15.50",
    Rating: "5",
    desc: "What it smells like: the sweet, airy treat you love. What it does: makes gifting so easy and puts a smile on their face.",
  },
  {
    id: "i6",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwc7b40597/crop/026447068_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Legend",
    category1: "3-in-1-Hair, Face & Body Wash",
    Amount: "14.50",
    Rating: "4.5",
    desc: "What it smells like: the sweet, airy treat you love. What it does: makes gifting so easy and puts a smile on their face.",
  },
  {
    id: "i7",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwf7d60f0c/crop/026447060_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Sport",
    category1: "Body Spray",
    Amount: "14.50",
    Rating: "5",
    desc: "What it smells like: the fragrance equivalent of your little black dress—beautiful, timeless and undeniably feminine. Fragrance notes: Japanese cherry blossom, Asian pear, fresh mimosa petals, white jasmine and blushing sandalwood.",
  },
  {
    id: "i8",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw1ee09012/crop/026439896_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Summer Melody",
    category1: "Fine Fragrance Mist",
    Amount: "16.50",
    Rating: "4.5",
    desc: "What it smells like: the fragrance equivalent of your little black dress—beautiful, timeless and undeniably feminine. Fragrance notes: Japanese cherry blossom, Asian pear, fresh mimosa petals, white jasmine and blushing sandalwood.",
  },
  {
    id: "i9",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwd01e376e/crop/026455072_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Summer Melody",
    category1: "Moisturizing Body Wash",
    Amount: "13.50",
    Rating: "4.5",
    desc: "What it smells like: the sweet, airy treat you love. What it does: makes gifting so easy and puts a smile on their face.",
  },
  {
    id: "i10",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwaf2aa500/crop/026455066_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Summer Melody",
    category1: "Shower Gel",
    Amount: "13.50",
    Rating: "4.5",
    desc: "What it smells like: the fragrance equivalent of your little black dress—beautiful, timeless and undeniably feminine. Fragrance notes: Japanese cherry blossom, Asian pear, fresh mimosa petals, white jasmine and blushing sandalwood.",
  },
  {
    id: "i11",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw83ed5a1d/crop/026285431_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Gold Glitter",
    category1: "Gift Bag",
    Amount: "3.50",
    Rating: "5",
    desc: "Why you'll love it: this one-of-a-kind gift for mom (or you) comes wrapped and ready to give. What's inside: 8 new favorites, including 4 exclusives you can't get anywhere else.",
  },
  {
    id: "i12",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwfb22f0dc/crop/026487392_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Sun-Washed Citrus",
    category1: "Gentle Foaming Hand Soaps",
    Amount: "7.50",
    Rating: "4.5",
    desc: "Why you'll love it: this one-of-a-kind gift for mom (or you) comes wrapped and ready to give. What's inside: 8 new favorites, including 4 exclusives you can't get anywhere else.",
  },
  {
    id: "i13",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwd822f759/crop/026517151_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Summer Boardwalk",
    category1: "Single Wick Candle",
    Amount: "15.50",
    Rating: "4",
    desc: "What it smells like: the fragrance equivalent of your little black dress—beautiful, timeless and undeniably feminine. Fragrance notes: Japanese cherry blossom, Asian pear, fresh mimosa petals, white jasmine and blushing sandalwood.",
  },
  {
    id: "i14",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwa469f92b/crop/026487360_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Orange Pineapple Punch",
    category1: "3-Wick Candle",
    Amount: "13.50",
    Rating: "4.5",
    desc: "What it smells like: the fragrance equivalent of your little black dress—beautiful, timeless and undeniably feminine. Fragrance notes: Japanese cherry blossom, Asian pear, fresh mimosa petals, white jasmine and blushing sandalwood.",
  },
  {
    id: "i15",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw90fbce9c/crop/026536756_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    name: "Leaves",
    category1: "3-Wick Candle",
    Amount: "13.35",
    Rating: "5",
    desc: "Why you'll love it: this one-of-a-kind gift for mom (or you) comes wrapped and ready to give. What's inside: 8 new favorites, including 4 exclusives you can't get anywhere else.",
  },
  {
    id: "i16",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw892fcb5e/crop/025144328_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    name: "Ocean",
    category1: "Mini Gift Set",
    Amount: "14.95",
    Rating: "5",
    desc: "Why you'll love it: this one-of-a-kind gift for mom (or you) comes wrapped and ready to give. What's inside: 8 new favorites, including 4 exclusives you can't get anywhere else.",
  },
  {
    id: "an17",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw22234b1a/crop/025145996_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Online Exclusive",
    name: "Pink Pineapple Sunrise",
    category1: "Single Wick Candle",
    Amount: "12.00",
    Rating: "3",
    desc: "What it smells like: the sweet, airy treat you love. What it does: makes gifting so easy and puts a smile on their face.",
  },
  {
    id: "an18",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw7143cf70/crop/025143597_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Online Exclusive",
    name: "Fresh Coconut",
    category1: "Fragrance Refill & Plug Bundle",
    Amount: "18.00",
    Rating: "5",
    desc: "What it smells like: the sweet, airy treat you love. What it does: makes gifting so easy and puts a smile on their face.",
  },
];
